export default {
  CURRENCY_PAIR: [
    'Ccy_Pair',
    'Ccy Pair',
    'CcyPair',
    'Currency Pair',
    'Currency_Pair',
    'CurrencyPair',
  ],
  CURRENCY_1: ['Ccy1', 'Ccy_1'],
  CURRENCY_2: ['Ccy2', 'Ccy_2'],
  TENOR: ['Tenor', 'Tnr'],
  TENOR1: ['Tenor_1', 'Tnr_1', 'Tenor1', 'Tnr1'],
  TENOR2: ['Tenor_2', 'Tnr_2', 'Tenor2', 'Tnr2'],
  TRADE_DATETIME: [
    'TradeDateTime',
    'Trade_Date_Time',
    'Trade_DateTime',
    'ExecutionDateTime',
    'Execution_Date_Time',
    'Execution_DateTime',
    'DealDateTime',
    'Deal_Date_Time',
    'Deal_DateTime',
  ],
  VALUE_DATE: ['Value_Date', 'ValueDate', 'ValDate'],
  MATURITY_DATE: ['Maturity_Date', 'MaturityDate', 'MatDate'],
  STRATEGY: ['Strategy', 'StrategyType', 'Strategy_Type', 'Strategy Type'],
  DELTA_STRIKE_PRICE: [
    'Delta Strike Price',
    'Delta_Strike_Price',
    'DeltaStrikePrice',
    'DeltaStrike',
    'Delta_Strike',
  ],
  SIDE: ['Side', 'Side String', 'Side_String', 'SideStr', 'Side_Str'],
  SECTOR: ['Sector'],
  PREMIUM_ACCOUNT: [
    'Premium Account',
    'Premium_Account',
    'PremiumAccount',
    'Premium_Ac',
    'Premium_Acc',
  ],
  PREMIUM_CURENCY: [
    'Premium Currency',
    'Premium_Currency',
    'PremiumCurrency',
    'Premium_Curr',
    'Premium_Ccy',
  ],
  NOTIONAL_AMOUNT: [
    'Notional Amount',
    'Notional_Amount',
    'NotionalAmount',
    'Notional_Amt',
    'Notional_Ammt',
  ],

  TIME_ZONE: ['Time Zone', 'Time_Zone', 'TimeZone', 'Tz'],
  STRIKE_PRICE_DELTA: ['Strike_Price_Delta'],
  OPTION_TYPE: ['Option Type', 'Option_Type', 'OptionType'],
  GAMMA: ['Gamma'],
  IMPLIED_VOLATILITY: [
    'Implied Volatility',
    'Implied_Volatility',
    'ImpliedVolatility',
    'Implied_Vol',
    'ImpliedVol',
  ],
  VEGA: ['Vega'],
  IS_DELIVERABLE: [
    'Is_Deliverable',
    'Is Deliverable',
    'IsDeliverable',
    'Is_Deliver',
    'Deliverable',
    'Deliver',
  ],
  BENCHMARK: ['Benchmark', 'Bench_Mark', 'Bmrk', 'Bm', 'Bench'],
  EXPLICIT_COST: [
    'Explicit Cost',
    'ExplicitCost',
    'Explicit_Cost',
    'ExplicitCosts',
    'Cost',
  ],
  ORDER_ID: ['Order ID', 'OrderID', 'Order_ID'],
  TRADE_ID: ['Trade ID', 'TradeID', 'Trade_ID', 'ID'],
  ORDER_TYPE: ['Order Type', 'OrderType', 'Order_Type'],
  SECURITY_TYPE: ['Security Type', 'SecurityType', 'Security_Type'],
  SECURITY_SUB_TYPE: [
    'Security Sub Type',
    'SecuritySubType',
    'Security_Sub_Type',
    'Security_SubType',
  ],
  INSTRUMENT_TYPE: ['Instrument Type', 'Instrument_Type', 'InstrumentType'],
  DESCRIPTION: ['Description'],
  TRADE_TYPE: ['Trade Type', 'TradeType', 'Trade_Type'],
  TRADER: [
    'Trader',
    'TraderName',
    'Trader Name',
    'Trader_Name',
    'TraderId',
    'Trader Id',
    'Trader_Id',
    'TraderCode',
    'Trader Code',
    'Trader_Code',
  ],
  DESK_LOCATION: [
    'Desk',
    'TradeDesk',
    'Trade Desk',
    'Trade_Desk',
    'Location',
    'Desk_Location',
    'DeskLocation',
    'Desk Location',
  ],
  COVER_PRICE: ['Cover_Price', 'CoverPrice', 'Cover Price'],
  LIMIT_PRICE: ['Limit_Price', 'LimitPrice', 'Limit Price'],
  ORDER_SIZE: ['Order Size', 'Order_Size', 'OrderSize'],
  EVENT_TYPE: ['Event_Type', 'EventType'],
  INSTRUCTIONS: ['Instructions'],
  PM: ['PM', 'PortfolioManager', 'Portfolio_Manager', 'Portfolio Manager'],
  ACCOUNT: ['Account', 'AccountName', 'Account_Name', 'Account Name'],
  FUND: ['Fund', 'FundType', 'Fund_Type', 'Fund Type'],
  DEALER_BROKER: ['Dealer Broker', 'Dealer', 'Dlr', 'Broker', 'Brkr', 'Brk'],
  PLATFORM_VENUE: [
    'PlatformVenue',
    'Platform_Venue',
    'Platform',
    'Venue',
    'Plat',
    'Ven',
  ],
  OTHER_IDS: ['Other_Ids', 'Other Ids', 'OtherIds'],
  CUSTOM_BENCHMARK_1: [
    'Custom_Benchmark_1',
    'CustomBenchmark1',
    'Custom_Benchmark1',
    'CustomBenchmark_1',
    'Custom Benchmark 1',
  ],
  OTHER: ['Other_1', 'Other1', 'Other 1'],
  LEGAL_ENTITY: ['entity', 'Entity', 'ENTITY'],
};
